export enum ClientStatusEnum {
  REGISTERED = 'registered',
  EMAIL_CONFIRMED = 'email_confirmed',
  ACTIVE = 'active',
  REJECTED = 'rejected',
  LOCKED = 'locked',
  ANONYMIZED = 'anonymized',
}
